const state = {
  sectionNumber: {
    before: 0,
    current: 0,
    after: 0
  },
  gnbType: "", // or "white"
  isDimmed: false
};

const getters = {
  sectionNumber(state) {
    return state.sectionNumber;
  },
  gnbType(state) {
    return state.gnbType;
  },
  isDimmed(state) {
    return state.isDimmed;
  }
};

const mutations = {
  SET_SECTION_NUMBER(state, payload) {
    state.sectionNumber = payload;
  },
  SET_GNB_TYPE(state, payload) {
    state.gnbType = payload;
  },
  SET_IS_DIMMED(state, payload) {
    state.isDimmed = payload;
  }
};

const actions = {
  setSectionNumber({ commit }, payload) {
    commit("SET_SECTION_NUMBER", payload);
  },
  setGnbType({ commit }, payload) {
    commit("SET_GNB_TYPE", payload);
  },
  setIsDimmed({ commit }, payload) {
    commit("SET_IS_DIMMED", payload);
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
